import {
    loadCategoryList,
    updateActive,
    insertCategory,
    updateCategory,
    deleteCategory,
    getCategoryListBin,
} from '@/service/category/category';
// import {
//   loadCategoryList,
//   updateActive,
//   insertCategory,
// } from "@/service/category/category";
import { uploadImage } from '@/service/upload/upload';
export default {
    data() {
        return {
            indexItem: null,
            status_toggle: 0,
            valid: true,
            alert: false,
            isOpen: false,
            imageFile: null,
            categoryName: '',
            categoryID: '',

            descriptionRules: [
                (v) => !!v || 'Description of the Category is required',
            ],
            description: 'Description of ENGLSIH WITH PETCH Category',

            categoryLogo: 'https://cdn.vuetifyjs.com/images/parallax/material2.jpg',

            imageReady: false,
            imageRules: [
                (v) =>
                    !v ||
                    v.size < 20000000 ||
                    v == '' ||
                    'Image size should be less than 20 MB!',
            ],

            filterdialog: false,
            deleteDialog: false,
            loading: true,
            sortType: ['ที่เพิ่มใหม่สุด', 'ที่เพิ่มเก่าสุด'],
            imageName: '',
            category: [],
            selectCategory: [],
            searchdata: '',
            sortData: '',
            searchCategory: null,
            pageCount: 1,
            limit: 10,
            imgPreview: '',
            skill: [],
            selectedSkill: [],
            selectedCategory: [],
            active: '',
            params: {},
            deleteItemID: [],
            categoryActive: false,
            actionEdit: '',
            levelSub: '',
            priority: '',
            dialogStatus: false,
            dialogStatusActive: false,
            dialogSuccess: false,
            dialogUsernameDuplicade: false,
            dialogAddFail: false,
            dialogAddSuccess: false,
            dialogEditSuccess: false,

            dialogRecycleBin: false,
            dialogRecover: false,
            loadingRecover: false,
            categoryBinItem: [],
            dialogFail: false,
            categoryListBin: [],
            pageCountBin: 0,
            paramsBin: {},

            preparePreview: '',
            imgURL: '',
            imgBool: false,
        };
    },
    async mounted() {
        await this.initialize();
        // console.log("window.screen.width:",window.screen.width/3)
    },
    computed: {
        pages() {
            if (
                this.pagination.rowsPerPage == null ||
                this.pagination.totalItems == null
            )
                return 0;

            return Math.ceil(
                this.pagination.totalItems / this.pagination.rowsPerPage
            );
        },
        fileRules() {
            const rules = [];

            // insert
            if (this.categoryID === '') {
                const rule = (v) =>
                    !!v || this.$vuetify.lang.t('$vuetify.categoryManagement.fileRules');
                rules.push(rule);
            }
            if (this.categoryID === '') {
                const rule = (v) =>
                    (v && v.size < 20000000) ||
                    this.$vuetify.lang.t('$vuetify.categoryManagement.fileRulesSize');
                rules.push(rule);
            }

            // update
            // if (this.categoryID !== "" && this.imageFile == "") {
            //   const rule = v => ( v && v.size < 5000000)  || "Image size should be less than 5 MB!";
            //   rules.push(rule);
            // }
            if (this.categoryID !== '') {
                const rule = (v) =>
                    (v ? (v.size < 20000000 ? true : false) : true) ||
                    this.$vuetify.lang.t('$vuetify.categoryManagement.fileRulesSize');
                rules.push(rule);
            }
            return rules;
        },
        categoryNameRules() {
            return [
                (v) =>
                    !!v ||
                    this.$vuetify.lang.t('$vuetify.categoryManagement.categoryNameRules'),
                (v) =>
                    (v && v.length <= 50) ||
                    this.$vuetify.lang.t(
                        '$vuetify.categoryManagement.categoryNameRulesLimit'
                    ),
            ];
        },
        headersBin() {
            return [
                {
                    text: this.$vuetify.lang.t('$vuetify.categoryManagement.photo'),
                    align: 'start',
                    sortable: false,
                    value: 'image',
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.categoryManagement.name'),
                    sortable: false,
                    align: 'start',
                    value: 'title',
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.categoryManagement.recover'),
                    align: 'center',
                    sortable: false,
                    value: 'edit',
                },
            ];
        },
        headers() {
            return [
                {
                    text: this.$vuetify.lang.t('$vuetify.categoryManagement.photo'),
                    align: 'left',
                    sortable: false,
                    value: 'image',
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.categoryManagement.name'),
                    value: 'title',
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.categoryManagement.createdDate'),
                    align: 'center',
                    value: 'date',
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.categoryManagement.statusHeader'
                    ),

                    value: 'active',
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.categoryManagement.editCategory'
                    ),
                    align: 'center',
                    value: 'actions',
                    sortable: false,
                },
            ];
        },
    },
    watch: {
        searchdata(keyword) {
            this.searchInfo(keyword);
        },
    },
    methods: {
        async initialize() {
            this.params = {
                search: this.searchCategory,
                sort: 'created_at',
                sortby: -1,
                page: 1,
                limit: 10,
                active: 'null',
            };
            this.paramsBin = {
                search: this.searchCategory,
                sort: 'priority',
                sortby: 1,
                page: 1,
                limit: 10,
                active: 'null',
            };
            this.searchdata = '';
            this.status_toggle = 0;

            if (!this.$store.state.permission.viewCategory) {
                this.noPermission();
            } else {
                await this.getCategoryList();
            }
        },
        searchInfo(keyword) {
            this.params.search = keyword;
            this.getCategoryList();
        },
        onSort() {
            if (this.status_toggle == 1) {
                this.params.active = true;
                this.getCategoryList();
            } else if (this.status_toggle == 2) {
                this.params.active = false;
                this.getCategoryList();
            } else {
                this.params.active = 'null';
                this.getCategoryList();
            }
        },
        // async preview() {
        //   console.log('imageFile', this.imageFile);
        //   if (this.imageFile != null) {
        //     if (this.imageFile.size > 20000000) return;
        //     this.imgURL = await this.uploadImg(this.imageFile);
        //     this.imgPreview = this.imgURL;
        //     this.imageReady = true;
        //   } else {
        //     if (this.preparePreview) {
        //       this.imgPreview = this.preparePreview;
        //       this.imageReady = true;
        //     } else {
        //       this.imageReady = false;
        //     }
        //   }
        // },
        async preview(event) {
            let file = event.target.files[0];

            this.imgURL = "";
            this.imageFile = file;
            this.imgPreview = await URL.createObjectURL(file);
            this.imageName = file.name;
            if (this.imgPreview) {
                this.imageReady = true;
            }
        },
        
        deleteItem(item) {
            let index = this.category.indexOf(item);
            let deleteID = this.category[index];
            this.categoryActive = deleteID.active;
            this.categoryID = deleteID.id;
            this.deleteDialog = true;
        },

        async confirmDelete() {
            if (this.categoryActive === true) {
                let statusActive = await updateActive({
                    id: this.categoryID,
                    active: false,
                });
                let status = await deleteCategory({
                    idcategory: this.categoryID,
                    istrash: true,
                });
                if (status.code == 403 || statusActive.code == 403) {
                    this.dialogFail = false;
                    this.deleteDialog = false;
                } else {
                    this.deleteDialog = false;
                    this.getCategoryList();
                }
            } else {
                let status = await deleteCategory({
                    idcategory: this.categoryID,
                    istrash: true,
                });
                if (status.code == 403) {
                    this.dialogFail = false;
                    this.deleteDialog = false;
                } else {
                    this.deleteDialog = false;
                    this.getCategoryList();
                }
            }
        },
        async openRecycleBin() {
            await this.getCategoryListIsTrash();
            this.dialogRecycleBin = true;
        },
        async changePageBin(page) {
            this.paramsBin.page = page;
            await this.getCategoryListIsTrash();
        },
        closeDialogRecover() {
            this.dialogRecycleBin = false;
        },
        async closeDialogRecycleBin() {
            this.dialogRecycleBin = false;
            await this.getCategoryList();
        },
        async getCategoryListIsTrash() {
            let result = await getCategoryListBin(this.paramsBin);
            this.categoryListBin = [];
            this.pageCountBin = result.maxPage;
            result.data.forEach((category) => {
                this.categoryListBin.push({
                    id: category._id,
                    image: category.image,
                    title: category.title,
                });
            });
        },
        confirmRecover(item) {
            this.categoryBinItem = item;
            this.dialogRecover = true;
        },
        async recoverCategory() {
            this.loadingRecover = true;
            let status = await deleteCategory({
                idcategory: this.categoryBinItem.id,
                istrash: false,
            });
            if (status.code == 403) {
                this.dialogFail = true;
            } else {
                this.deleteDialog = false;
                await this.getCategoryListIsTrash();
            }
            this.loadingRecover = false;
            this.dialogRecover = false;
            if (this.categoryListBin.length == 0) {
                this.dialogRecycleBin = false;
            }
            this.categoryBinItem = null;
            this.page = 1;
            this.pageCount - 1;
            await this.initialize();
        },

        refreshFilter() {
            this.initialize();
        },
        async onUpload() {
            let isValidForm = true;
            let isValidImg = true;

            if (this.categoryName.length > 2 && this.categoryName.length <= 50) {
                isValidForm = true;
            } else {
                isValidForm = false;
            }

            if (
                this.imageFile == '' &&
                this.preparePreview == '' &&
                this.imgPreview == ''
            ) {
                isValidImg = false;
            } else {
                isValidImg = true;
            }

            if (isValidForm == true && isValidImg == true) {
                await this.insertCate();
                await this.getCategoryList();
            }
        },
        async getCategoryList() {
            this.loading = true;
            let result = await loadCategoryList(this.params);
            this.category = [];
            this.pageCount = result.maxPage;
            result.data.forEach((category) => {
                this.category.push({
                    id: category._id,
                    title: category.title,
                    image: category.image,
                    date: category.created_at,
                    active: category.active,
                    priority: category.priority,
                    levelSub: category.levelSub,
                });
            });
            this.loading = false;
        },
        async uploadImg(image) {
            let status = await uploadImage('category', image);
            return status;
        },

        async insertCate() {
            if (this.actionEdit == 'edit') {
                let body = {};
                if (this.imageFile == '' || this.imageFile == null) {
                    body = {
                        id: this.categoryID,
                        title: this.categoryName,
                        image: this.preparePreview,
                        active: this.categoryActive,
                        priority: this.priority,
                        levelSub: this.levelSub,
                        categories: [],
                    };
                } else {
                    this.imgBool = true;
                    this.imgURL = await this.uploadImg(this.imageFile);
                    body = {
                        id: this.categoryID,
                        title: this.categoryName,
                        image: this.imgURL,
                        active: this.categoryActive,
                        priority: this.priority,
                        levelSub: this.levelSub,
                        categories: [],
                    };
                }

                let status = await updateCategory(body);
                this.imgBool = false;
                if (status.message == 'category name duplicate') {
                    this.dialogUsernameDuplicade = true; //กรณีชื่อซ้ำ
                    this.categoryName = '';
                } else if (status.code == 403) {
                    this.dialogAddFail = true; //กรณี error อื่น
                } else {
                    this.dialogEditSuccess = true;
                    this.getCategoryList();

                    this.categoryID = '';
                    this.categoryName = '';
                    this.imageFile = null;
                    this.imgPreview = '';
                    this.$refs.form.resetValidation();
                    this.imageReady = false;
                    this.isOpen = false;
                    this.imageName = '';
                }
            } else {
                let statusAdd = '';
                if (this.imageFile == '' || this.imageFile == null) {

                    statusAdd = await insertCategory({
                        title: this.categoryName,
                        image: this.imgURL,
                        active: true,
                    });
                } else {
                    this.imgBool = true;
                    this.imgURL = await this.uploadImg(this.imageFile);
                    statusAdd = await insertCategory({
                        title: this.categoryName,
                        image: this.imgURL,
                        active: true,
                    });
                }
                this.imgBool = false;
                if (statusAdd.message == 'category name duplicate') {
                    this.dialogUsernameDuplicade = true; //กรณีชื่อซ้ำ
                    this.categoryName = '';
                } else if (statusAdd.code == 403) {
                    this.dialogAddFail = true; //กรณี error อื่น
                } else {
                    this.dialogAddSuccess = true;
                    this.getCategoryList();

                    this.categoryID = '';
                    this.categoryName = '';
                    this.imageFile = null;
                    this.imgPreview = '';
                    this.$refs.form.resetValidation();
                    this.imageReady = false;
                    this.isOpen = false;
                    this.imageName = '';
                }
            }
            // console.log(this.categoryName),
            // console.log(this.imgURL);
        },

        noPermission() {
            this.alert = true;
        },
        async changePage(page) {
            this.params.page = page;
            await this.getCategoryList();
        },
        editItem(item) {
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
                this.imageReady = false;
                this.categoryID = '';
                this.categoryName = '';
                this.imageFile = null;
                this.imgPreview = '';
                this.preparePreview = '';
                this.actionEdit = '';
            }
            if (item) {
                let index = this.category.indexOf(item);
                let editCategory = this.category[index];

                this.categoryID = editCategory.id;
                this.categoryName = editCategory.title;
                this.imgPreview = editCategory.image;
                this.preparePreview = editCategory.image; //valid image
                this.categoryActive = editCategory.active;
                this.priority = editCategory.priority;
                this.levelSub = editCategory.levelSub;

                this.actionEdit = 'edit';
            }
            this.isOpen = true;
        },
        closeDialog() {
            this.categoryID = '';
            this.imageName = '';
            this.categoryName = '';
            this.imageFile = null;
            this.imgPreview = '';
            this.imgURL = "";
            this.preparePreview = ''; //valid image

            this.$refs.form.resetValidation();
            this.isOpen = false;
            this.imageReady = false;
        },
        openModalStatus(item) {
            let index = this.category.indexOf(item);
            this.indexItem = index;
            if (this.category[index].active == true) {
                this.dialogStatus = true;
                this.updateActiveId = this.category[index].id;
                this.updateActive = this.category[index].active;
            } else {
                this.dialogStatusActive = true;
                this.updateActiveId = this.category[index].id;
                this.updateActive = this.category[index].active;
            }
        },
        async updateActiveCategory() {
            if (this.updateActive == true) {
                let status = await updateActive({
                    id: this.updateActiveId,
                    active: false,
                });
                this.dialogStatus = false;
                this.dialogSuccess = true;
                this.getCategoryList();
                return status;
            } else {
                let status = await updateActive({
                    id: this.updateActiveId,
                    active: true,
                });
                this.dialogStatusActive = false;
                this.dialogSuccess = true;
                this.getCategoryList();
                return status;
            }
        },
        cancelStatus() {
            this.dialogStatus = false;
            this.category[this.indexItem].active = this.updateActive;
        },
        cancelStatusActive() {
            this.dialogStatusActive = false;
            this.category[this.indexItem].active = this.updateActive;
        },
        // editItem(item) {
        //   let index = this.category.indexOf(item);
        //   let editCategory = this.category[index];

        //   this.$router.push({
        //     path: "/category/detail",
        //     query: { id: editCategory.id }
        //   });
        // },
    },
};
